import { NgModule, ErrorHandler } from '@angular/core';

import { TokenInterceptor } from './interceptors/api-request.interceptor';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { GlobalErrorHandlerService } from './services/http-error-handler.service';
import { AdminWrapperComponent, CallbackComponent } from './components';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { LoadersModule } from '@ceslicensing/loaders';
import { ButtonModule } from '@ceslicensing/button';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [AdminWrapperComponent, CallbackComponent],
  imports: [
    CommonModule,
    HttpClientModule,
    ButtonsModule,
    LoadersModule,
    ButtonModule,
    RouterModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true,
    },
    { provide: ErrorHandler, useClass: GlobalErrorHandlerService },
  ],
  bootstrap: [],
})
export class CoreModule {}
